'use client';

import { useSearchParams } from 'next/navigation';
import kebabCase from 'lodash/kebabCase';
import { TextLayout, type TextLayoutBody } from '@/components/text-layout';
import type { FormBlock as Props } from '@/app/generated/graphql';
import { SEARCH_PARAMS } from '@/constants';

const DEFAULT_HEIGHT = 800;

export const IframeForm = ({ props }: { props: Props }) => {
  const selectedPlan = useSearchParams().get(
    SEARCH_PARAMS.formStack.selectedPlan
  );
  const formStackSearchParams = selectedPlan
    ? `?${SEARCH_PARAMS.formStack.selectedPlan}=${selectedPlan}`
    : '';

  return (
    <div
      id={kebabCase(props.heading!)}
      className="container pt-i"
    >
      <div className="grid grid-cols-12 lg:grid-cols-6">
        <div className="col-span-12 flex flex-col text-center lg:col-span-4 lg:col-start-2">
          <TextLayout
            {...props}
            body={props.body as TextLayoutBody}
            headingAccent="centered"
          />
        </div>
        <div className="col-span-12 mt-b flex flex-col text-center lg:col-span-4 lg:col-start-2">
          <iframe
            src={`${process.env.NEXT_PUBLIC_FORMSTACK_URL}/forms/${props.formId}${formStackSearchParams}`}
            title={`${props.heading} form`}
            height={props.height || DEFAULT_HEIGHT}
          />
        </div>
      </div>
    </div>
  );
};
